// import delegateEvent from '../utilities/delegateEvent.js';

export default function ImagesLoaded() {
  return {
    init: () => {
      const images = document.querySelectorAll('*:not([data-w-map]) img');
      if (!images) return;

      images.forEach((img) => {
        if (img.complete) {
          img.classList.add('w-is-loaded');
        } else {
          img.addEventListener('load', () => {
            img.classList.add('w-is-loaded');
          });
        }
      });
    },
  };
}
